import { Box, CircularProgress, circularProgressClasses } from '@mui/material';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '120px',
  },
}));

const Spinner = (props) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.container}
      sx={{
        padding: (theme) => `${theme.spacing(props?.padding ?? '120px')} !important`,
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          sx={(theme) => ({
            color: theme.palette.grey[200],
            ...theme.applyStyles('dark', {
              color: theme.palette.grey[800],
            }),
          })}
          size={40}
          thickness={4}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={(theme) => ({
            color: theme.palette.primary.main,
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
            ...theme.applyStyles('dark', {
              color: '#308fe8',
            }),
          })}
          size={40}
          thickness={4}
          {...props}
        />
      </Box>
    </Box>
  );
};

export default Spinner;
